export default __webpack_public_path__ + "static/media/cloud.ba60f6ba.png";